export const ANALYTICS_EVENT = 'addEvents_oldma';
